export enum CcaRateChartTypeEnum {
  CostPerTripAndStudentType = "cost_per_trip_and_student_type",
  CostPerTripAndStudentArea = "cost_per_trip_based_on_area",
  CostPerWeek = "cost_per_week",
  NoCostCalculation = "no_cost_calculation",
}

export const statusList = [
  { id: "active", name: "Active" },
  { id: "inactive", name: "Inactive" },
];

export const areaCalculationType = [
  { id: "line", name: "Line" },
  { id: "route", name: "Route" },
];

export const pricingPolicyList = [
  { id: "contactDays", name: "Contact Days" },
  { id: "fullCalendarDays", name: "Full Calendar Days" },
];

export const ccaDropOffLocationType = [
  { id: "door_to_door", name: "Door To Door" },
  { id: "fixed_location", name: "Fixed Location" },
  { id: "both", name: "Both" },
];

export const ccaRateChartType = [
  { id: CcaRateChartTypeEnum.CostPerTripAndStudentType, name: "Cost Per Trip Based On Student Type" },
  { id: CcaRateChartTypeEnum.CostPerTripAndStudentArea, name: "Cost Per Trip Based On Area" },
  { id: CcaRateChartTypeEnum.CostPerWeek, name: "Cost Per Week" },
  { id: CcaRateChartTypeEnum.NoCostCalculation, name: "No Cost Calculation" },
];

export const paymentMethodType = [
  { id: "pay_now_and_credit_card", name: "PayNow and Credit Card" },
  { id: "pay_now", name: "PayNow Only" },
];
